import { ExtensionType, settings, extensions } from '@pixi/core';
var resolveCompressedTextureUrl = {
  extension: ExtensionType.ResolveParser,
  test: function test(value) {
    var temp = value.split("?")[0];
    var extension = temp.split(".").pop();
    return ["basis", "ktx", "dds"].includes(extension);
  },
  parse: function parse(value) {
    var _settings$RETINA_PREF3, _settings$RETINA_PREF4;
    var temp = value.split("?")[0];
    var extension = temp.split(".").pop();
    if (extension === "ktx") {
      var extensions2 = [".s3tc.ktx", ".s3tc_sRGB.ktx", ".etc.ktx", ".etc1.ktx", ".pvrt.ktx", ".atc.ktx", ".astc.ktx"];
      if (extensions2.some(function (ext) {
        return value.endsWith(ext);
      })) {
        var _settings$RETINA_PREF, _settings$RETINA_PREF2;
        return {
          resolution: parseFloat((_settings$RETINA_PREF = (_settings$RETINA_PREF2 = settings.RETINA_PREFIX.exec(value)) === null || _settings$RETINA_PREF2 === void 0 ? void 0 : _settings$RETINA_PREF2[1]) !== null && _settings$RETINA_PREF !== void 0 ? _settings$RETINA_PREF : "1"),
          format: extensions2.find(function (ext) {
            return value.endsWith(ext);
          }),
          src: value
        };
      }
    }
    return {
      resolution: parseFloat((_settings$RETINA_PREF3 = (_settings$RETINA_PREF4 = settings.RETINA_PREFIX.exec(value)) === null || _settings$RETINA_PREF4 === void 0 ? void 0 : _settings$RETINA_PREF4[1]) !== null && _settings$RETINA_PREF3 !== void 0 ? _settings$RETINA_PREF3 : "1"),
      format: value.split(".").pop(),
      src: value
    };
  }
};
extensions.add(resolveCompressedTextureUrl);
export { resolveCompressedTextureUrl };